export const FETCH_CHANGE_REMINDER_VALUES = "FETCH_CHANGE_REMINDER_VALUES";
export const OPEN_CHANGE_REMINDER = "OPEN_CHANGE_REMINDER";
export const SKIP_CHANGE_REMINDER = "SKIP_CHANGE_REMINDER";
